import React from 'react'
import Link from 'next/link'
import { ButtonVariant, OvalButton, Spacer, WorkArea } from '@revelrygroup/components'

import { Case, FlowerProduct, ObituarySnippet } from '../../types'
import EventTrackingModel from '../models/EventTrackingModel'
import FlowerstoreProducts from '../FlowerstoreProducts'
import { routes } from '../../routes'

interface Props {
  backgroundColor?: string
  obituary: ObituarySnippet | Case
  products: FlowerProduct[]
  title?: string
}

const FlowerRow: React.FC<Props> = ({ backgroundColor = '#eaeaea', obituary, products, title }) => {
  React.useEffect(() => {
    EventTrackingModel.trackViewFlowers(products, 'flower_row')
  }, [])

  return (
    <WorkArea className="print-hide" style={{ backgroundColor }}>
      <h2 className="h3 centered-text">{title || 'Send Flowers'}</h2>

      <FlowerstoreProducts gaTrackingList="flower_row" obituary={obituary} products={products} />

      <Spacer verticalTop="sm">
        <div className="centered-text">
          <Link href={routes.flowerstore(obituary)}>
            <OvalButton as="anchor" variant={ButtonVariant.INVERSE_DARK}>
              Browse All Flowers
            </OvalButton>
          </Link>
        </div>
      </Spacer>
    </WorkArea>
  )
}

export default FlowerRow
